module.exports = __webpack_public_path__ + "img/proof-dough.8b1b51db.svg";